module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARCAYAAAAyhueAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALZJREFUeNpiYCANTADiZGSB////Y2BSgBAQPwSZg2wwpYaCgCIQP0E2mBqGohucQC1DQUAFn8GUAHUgfg7Ef9ANphQgGxwLM5QRyJEDYlEKDNYC4jlAzAzEiUBDF4MEp0HDhhoY5GIDFiCxDIgvUOBSHiBuAWJOIJ4OdOkFSsMUZNBhqCunUSOisBpIiaEgAw9ADZxJjXQKMnAX1MA51MhRKAZSK+9vhxo4n5qlVAKygbgMBQgwAF4z6vYm+mZhAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/arrow-right-noir.png
// module id = 91
// module chunks = 0